const progressBarChapterSegmentTemplate = ({chapterIndex}) => `<div class="progress-bar-chapter" data-chapter-index="${chapterIndex}">
   <div class="ui scrubbar-background-track"></div>
   <div class="ui scrubbar-loaded-track load-progress"></div>
   <div class="ui scrubbar-seek-hint-track seek-hint-progress"></div>
   <div class="ui scrubbar-played-track play-progress"></div>
</div>`;

export default progressBarChapterSegmentTemplate;
